import * as Yup from "yup";

export const SearchCodeValidationSchema = () => {
  return Yup.object().shape({
    unique_code: Yup.string().nullable().required("required"),
  });
};
